import { render, staticRenderFns } from "./DnsRecordsManagement.vue?vue&type=template&id=444e3844&scoped=true&"
import script from "./DnsRecordsManagement.vue?vue&type=script&lang=js&"
export * from "./DnsRecordsManagement.vue?vue&type=script&lang=js&"
import style0 from "./DnsRecordsManagement.vue?vue&type=style&index=0&id=444e3844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e3844",
  null
  
)

export default component.exports